import React, { useState, useEffect } from "react";
import { 
    Form, Input, Button, Row, Col, notification, Select, Table, Radio, 
    Space, Empty, Popconfirm, Modal, Cascader, Checkbox, Tooltip, Tag
} from "antd";
import { PlusOutlined, InfoCircleOutlined } from '@ant-design/icons';
import {
    getTemplateLoginItems, putTemplateLoginItems, 
    deleteLoginItems, deleteLoginItem
} from "../../../axios/api.device"
import { gaEvent } from "../../../withTracker"

import { useTranslation } from "react-i18next";
import TextArea from "antd/lib/input/TextArea";

const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentLoginItem = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<any>([]);
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [selectedItemId, setSelectedItemId] = useState<string>("");
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [dataForm] = Form.useForm();
    const [ruleType, setRuleType] = useState<string>("BundleIdentifier");

    const { t } = useTranslation();

    var addClick = () => { setShowTable(2) }

    useEffect(() => { getDataInfo() }, [])

    const getDataInfo = async () => {
        setShowTable(1)
        await getTemplateLoginItems(templateId).then((res) => {
            if (res.length > 0) {
                setShowTable(2);
                setData(res);
                // setTimeout(() => {
                // }, 500);
            } else {
                setShowTable(1)
            }
        })
    }

    const addTemplateClick = () => {
        dataForm?.validateFields().then((res) => {
            var params: any = {}
            res.packageList = res.packageList ? res.packageList.filter((item: any) => item) : [];
            params = res;
            params["id"] = selectedItemId;
            
            putTemplateLoginItems(templateId, params).then(() => {
                updateTemplate();
                notification.success({ message: t("操作成功") });
                dataForm.resetFields();
                setModalVisible(false);
                setSelectedItemId("");
                getDataInfo();
            })
        })
    }

    const removeSystemExtension = (id: string) => {
        deleteLoginItem(templateId, id).then(() => {
            notification.success({ message: t("操作成功") });
            if (data.length === 1) {
                setData([]);
                updateTemplate();
            }
            getDataInfo();
        })
    }

    const deleteTemplateClick = () => {
        deleteLoginItems(templateId).then(() => {
            updateTemplate();
            notification.success({ message: t("成功") });
            dataForm.resetFields();
            setData([]);
            getDataInfo();
        })
    }

    const addExtension = () => {
        dataForm.resetFields();
        setIsEdit(false);
        setModalVisible(true);
    }

    const editExtension = (row: any) => {
        dataForm.setFieldsValue(row)
        setSelectedItemId(row.id);
        setIsEdit(true);
        setModalVisible(true);
    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("管理登录项")}</Col>
                <Col style={{ marginLeft: 36 }}>
                    <Tooltip title={t("可在macOS 13.0及更高版本中使用")}>
                        <Tag color="cyan">macOS 13.0+</Tag>
                    </Tooltip>
                </Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>{t("设置受管理的登录项在后台运行，不会在前台向用户展示。")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick() }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <>
                        <div className="tAr">
                            <Button type="primary" onClick={ addExtension }><PlusOutlined />{t("添加管理登录项")}</Button>
                        </div>
                        <Table 
                            dataSource={data} 
                            rowKey="id"
                            style={{ width: "100%" ,marginLeft:8}}
                            locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                        >
                            <Table.Column
                                title={t("规则类型")}
                                key="ruleType"
                                dataIndex="ruleType"
                            ></Table.Column>
                            <Table.Column
                                title={t("规则值")}
                                key="ruleValue"
                                dataIndex="ruleValue"
                            ></Table.Column>
                            <Table.Column
                                title={t("团队标识符")}
                                key="teamIdentifier"
                                dataIndex="teamIdentifier"
                            ></Table.Column>
                            <Table.Column
                                title={t("备注")}
                                key="comment"
                                dataIndex="comment"
                            ></Table.Column>
                            <Table.Column
                                title={t("操作")}
                                key="id"
                                dataIndex="id"
                                render={(id, row) => {
                                    return (
                                        <Space size={8}>
                                            <Button type="link" block onClick={() => { editExtension(row) }}>{t("编辑")}
                                            </Button>
                                            <Popconfirm
                                                title={`${t("确认移除")}？`}
                                                onConfirm={() => { removeSystemExtension(id) }}
                                                okText={t("确认")}
                                                cancelText={t("取消")}
                                            >
                                                <Button type="link" block>{t("移除")}</Button>
                                            </Popconfirm>
                                        </Space>
                                    )
                                }}
                            ></Table.Column>
                        </Table>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            {/* <Button style={{ width: 100 }} type="primary" onClick={() => { batchUpdate() }}> {t("保存")} </Button> */}
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick() }}>{t("删除规则")}</Button>
                        </div>

                        <Modal
                            confirmLoading={loading}
                            open={modalVisible}
                            maskClosable={false}
                            destroyOnClose={true}
                            title={t("管理登录项")}
                            forceRender={true}
                            onOk={() => { addTemplateClick() }}
                            onCancel={() => { setModalVisible(false); dataForm.resetFields(); setSelectedItemId("") }}
                            okText={t("确认")}
                            cancelText={t("取消")}
                        >
                            <Form
                                form={dataForm}
                                layout="vertical"
                                initialValues={{ruleType: "BundleIdentifier"}}
                            >
                                <Form.Item label={t("规则类型")} name="ruleType" rules={[{required: true}]}>
                                    <Select onChange={(value: string) => { setRuleType(value); }}>
                                        <Select.Option value="BundleIdentifier">{t("BundleIdentifier")}</Select.Option>
                                        <Select.Option value="BundleIdentifierPrefix">{t("BundleIdentifierPrefix")}</Select.Option>
                                        <Select.Option value="Label">{t("Label")}</Select.Option>
                                        <Select.Option value="LabelPrefix">{t("LabelPrefix")}</Select.Option>
                                        <Select.Option value="TeamIdentifier">{t("TeamIdentifier")}</Select.Option>
                                    </Select>
                                </Form.Item>
                                
                                <Form.Item label={t("规则值")} name="ruleValue" rules={[{required: true}]}>
                                    <Input></Input>
                                </Form.Item>
                                {ruleType !== "TeamIdentifier" && <>
                                    <Form.Item label={t("团队标识符")} name="teamIdentifier">
                                        <Input></Input>
                                    </Form.Item>
                                </>}
                                <Form.Item label={t("备注")} name="comment">
                                    <TextArea rows={4}></TextArea>
                                </Form.Item>
                            </Form>
                        </Modal>
                    </>
                )}
            </Row>
        </div>

    </>)
};